import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { lowlight, init } from '../../../common/lib/lowlight';
import { CodeBlockComponent } from './CodeBlockComponent';
init();
export const CodeBlock = CodeBlockLowlight.extend({
    addNodeView: () => ReactNodeViewRenderer(CodeBlockComponent),
    // for some reason addAttributes from @tiptap/extension-code-block is not called automatically
    // otherwise parsing language class from html is not working
    addAttributes() {
        return {
            language: {
                default: null,
                parseHTML: element => {
                    let _a;
                    const { languageClassPrefix } = this.options;
                    const classNames = [
                        // eslint-disable-next-line no-cond-assign,no-void
                        ...(((_a = element.firstElementChild) === null || _a === void 0
                            ? // eslint-disable-next-line no-void
                                void 0
                            : _a.classList) || []),
                    ];
                    const languages = classNames
                        .filter(className => className.startsWith(languageClassPrefix))
                        .map(className => className.replace(languageClassPrefix, ''));
                    const language = languages[0];
                    if (!language) {
                        return null;
                    }
                    return language;
                },
                renderHTML: attributes => {
                    if (!attributes.language) {
                        return null;
                    }
                    return {
                        class: this.options.languageClassPrefix + attributes.language,
                    };
                },
            },
        };
    },
}).configure({
    lowlight,
});
//# sourceMappingURL=CodeBlock.js.map